import React, { useState } from 'react';
import { isBlank } from 'utils/helperMethods';
import { keys, includes, uniq, filter, isEmpty, pluck, find, propEq, pathOr } from 'ramda';
import PropTypes from 'prop-types';

import ChatPresenter from 'presenters/ChatPresenter';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography, TextField } from '@material-ui/core';
import Modal from 'sharedComponents/Modal';
import LoanOfficerCard from './components/LoanOfficerCard';

import useStyles from './useStyles';

const VideoUploader = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { chats, onClose, onBulkMessageSend, currentUserId, chatsInfo } = props;
  const { usersOnlineStatusList } = useFirebaseChat();

  const [state, setState] = useState({ checkedChatUids: pluck('uid', chats), messageText: '' });

  const handleCheckChat = uid => ({ target: { checked } }) => {
    const checkedChatUids = checked
      ? uniq([...state.checkedChatUids, uid])
      : filter(chatUid => chatUid !== uid, state.checkedChatUids);
    setState({ ...state, checkedChatUids });
  };

  const handleSendMesage = () => {
    const message = { data: state.messageText, type: 'text', senderId: currentUserId };
    const params = state.checkedChatUids.map(chatUid => {
      const chat = find(propEq('uid', chatUid), chats);
      return { chatUid, participantId: FirebaseChatPresenter.loanOfficerId(chat) };
    });
    onBulkMessageSend(params, message);
  };

  const handleTextFieldChange = ({ target: { value } }) => {
    setState({ ...state, messageText: value });
  };

  const canSendMessage = !isEmpty(state.messageText) && !isEmpty(state.checkedChatUids);

  return (
    <Modal onClose={onClose} header closeButton label={t('components.BulkMessaging.popupHeader')}>
      <Box display="flex" flexDirection="column">
        <Box>
          {chats.map((chat, index) => {
            const isLast = index === keys(chats).length - 1;
            const chatUid = FirebaseChatPresenter.uid(chat);
            const loanOfficerId = FirebaseChatPresenter.loanOfficerId(chat);
            const checked = includes(chatUid, state.checkedChatUids);
            const chatInfo = chatsInfo[chatUid];
            const loanOfficer = isBlank(chatInfo) ? null : ChatPresenter.loanOfficer(chatInfo);
            const isOnline = pathOr(false, [loanOfficerId, 'isOnline'], usersOnlineStatusList);
            return (
              <LoanOfficerCard
                key={chatUid}
                onChecked={handleCheckChat(chatUid)}
                checked={checked}
                loanOfficer={loanOfficer}
                isOnline={isOnline}
                divider={!isLast}
              />
            );
          })}
        </Box>
        <Typography variant="subtitle1" color="secondary">
          {t('components.BulkMessaging.message')}
        </Typography>
        <TextField
          multiline
          className={classes.textField}
          variant="outlined"
          rows={5}
          onChange={handleTextFieldChange}
          value={state.messageText}
          placeholder={t('components.BulkMessaging.textPlaceholder')}
        />
        <Button className={classes.sendButton} onClick={handleSendMesage} disabled={!canSendMessage}>
          {t('components.BulkMessaging.sendButton')}
        </Button>
      </Box>
    </Modal>
  );
};

VideoUploader.propTypes = {
  chats: PropTypes.arrayOf(FirebaseChatPresenter.shape()).isRequired,
  chatsInfo: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  currentUserId: PropTypes.number.isRequired,
  onBulkMessageSend: PropTypes.func.isRequired,
};

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/BulkMessaging/BulkMessaging.js